export enum PaymentType {
  onlinePayment = 0,
  check = 1,
  onlinePaymentOrCheck = 2
}